/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendExpensesToPunchoutRequest
 */
export interface SendExpensesToPunchoutRequest {
    /**
     * 
     * @type {string}
     * @memberof SendExpensesToPunchoutRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the SendExpensesToPunchoutRequest interface.
 */
export function instanceOfSendExpensesToPunchoutRequest(value: object): value is SendExpensesToPunchoutRequest {
    return true;
}

export function SendExpensesToPunchoutRequestFromJSON(json: any): SendExpensesToPunchoutRequest {
    return SendExpensesToPunchoutRequestFromJSONTyped(json, false);
}

export function SendExpensesToPunchoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendExpensesToPunchoutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function SendExpensesToPunchoutRequestToJSON(value?: SendExpensesToPunchoutRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
    };
}

